import { QueryFunctionContext } from "@tanstack/react-query";

import { removeNonNumber } from "cc-tools/helpers";

import { fetchClient } from "checkout-query-client/api/fetch-client";
import { IsCreditCardProps } from "checkout-query-client/hooks/use-is-credit-card-with-surcharge";
import { usePubSub } from "checkout-query-client/hooks/use-pub-sub";
import {
  PubSubMessage,
  PubSubNamespace,
} from "checkout-query-client/publish-subcriber/types";

import { valueEncrypt } from "encrypt-value/encrypt";

import { GetBinDataRequest } from "frontend-client";

export const fetchCardData = async ({
  queryKey: [
    {
      cardNumber = "",
      experienceType,
      encryptionKey = "",
      apiHost = "",
      version = "",
      checkoutSessionToken = "",
    },
  ],
}: QueryFunctionContext<
  Array<
    IsCreditCardProps & {
      scope:
        | "card-type"
        | "card-type-for-surcharge"
        | "card-networks-api-lookup";
    }
  >
>) => {
  let encryptedPan = "";
  try {
    if (experienceType === "dropInUI") {
      encryptedPan = cardNumber;
    } else {
      const encryptedPanData = await valueEncrypt({
        value: removeNonNumber(cardNumber),
        key: encryptionKey,
      });
      encryptedPan = encryptedPanData.encryptedData;
    }
  } catch (e) {
    usePubSub().publish({
      level: "error",
      namespace: PubSubNamespace.payment,
      message: PubSubMessage.CreditCardEncryptionError,
    });
    throw new Error("Encryption failed");
  }

  // For testing purposes:
  // const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
  // await delay(20000);
  return fetchClient({
    apiHost,
    version,
  }).getBinData(new GetBinDataRequest({ encryptedPan }), {
    headers: {
      Authorization: `Bearer ${checkoutSessionToken}`,
    },
  });
};
